(function () {
  'use strict';

  /* ---------------- Drawers ---------------- */
  var lastFocus = null;

  function focusables(el) {
    return el.querySelectorAll('a[href],button:not([disabled]),input:not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])');
  }

  window.openDrawer = function (id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var f = focusables(drawer);
    if (f.length) setTimeout(function () { f[0].focus(); }, 60);
  };

  window.closeDrawer = function (id) {
    var drawer = typeof id === 'string' ? document.getElementById(id) : id;
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.drawer.is-open')) document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      window.openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      window.closeDrawer(closer.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', function (e) {
    var open = document.querySelector('.drawer.is-open');
    if (!open) return;
    if (e.key === 'Escape') { window.closeDrawer(open); return; }
    if (e.key === 'Tab') {
      var f = focusables(open);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------- Sticky / transparent header ---------------- */
  var headerWrap = document.querySelector('[data-header]');
  if (headerWrap && headerWrap.hasAttribute('data-transparent')) {
    var onScroll = function () {
      if (window.scrollY > 40) headerWrap.classList.remove('is-transparent');
      else headerWrap.classList.add('is-transparent');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- Reveal on scroll ---------------- */
  var reveals = document.querySelectorAll('.fade-in');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------------- Product gallery ---------------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var viewport = gallery.querySelector('.gallery__viewport');
    var dots = gallery.querySelectorAll('.gallery__dots button');
    if (!viewport) return;

    function goTo(i) {
      var slide = viewport.children[i];
      if (slide) viewport.scrollTo({ left: slide.offsetLeft - viewport.offsetLeft, behavior: 'smooth' });
    }
    function current() {
      return Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1));
    }
    gallery.querySelectorAll('[data-gallery-prev]').forEach(function (b) {
      b.addEventListener('click', function () { goTo(Math.max(current() - 1, 0)); });
    });
    gallery.querySelectorAll('[data-gallery-next]').forEach(function (b) {
      b.addEventListener('click', function () { goTo(Math.min(current() + 1, viewport.children.length - 1)); });
    });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); }); });
    viewport.addEventListener('scroll', function () {
      var i = current();
      dots.forEach(function (d, di) { d.setAttribute('aria-current', di === i ? 'true' : 'false'); });
    }, { passive: true });
  });

  /* ---------------- Image zoom ---------------- */
  var zoom = document.getElementById('ImageZoom');
  if (zoom) {
    document.addEventListener('click', function (e) {
      var img = e.target.closest('[data-zoom-src]');
      if (!img) return;
      zoom.querySelector('img').src = img.getAttribute('data-zoom-src');
      zoom.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    zoom.addEventListener('click', function () {
      zoom.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  /* ---------------- Predictive search ---------------- */
  var searchInput = document.querySelector('[data-predictive-input]');
  var searchResults = document.querySelector('[data-predictive-results]');
  if (searchInput && searchResults) {
    var timer = null;
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      timer = setTimeout(function () {
        var url = window.BYLILY.routes.predictive_search +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-predictive-inner]');
            searchResults.innerHTML = inner ? inner.innerHTML : '';
          })
          .catch(function () { searchResults.innerHTML = ''; });
      }, 250);
    });
  }

  /* ---------------- Quantity steppers ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap.querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    val += parseInt(btn.getAttribute('data-qty-change'), 10);
    input.value = Math.max(1, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
